// prettier-ignore
export const EMAIL_VALIDATOR_PATTERN = "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-z]{2,4}$";
// prettier-ignore
export const PASSWORD_VALIDATOR_PATTERN =
  '^(?=.*[0-9])(?=.*[!@#$%^&*?_-])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*?_-]{8,}$';
